import { Loader } from "@dbn/omnichannel-design-system-g4p";
import { constVoid, pipe } from "fp-ts/function";
import { useQuery } from "../../../useAPI";
import * as remoteData from "../../../RemoteData";
import * as api from "../../api";
import { RuntimeLocaleKey, useFormatMessage } from "../../../intl";
type Props = {
  onFinish: (hasIncomes: boolean) => void;
  onError: () => void;
};

export function AdditionalIncomesCheck(props: Props) {
  const [getAdditionalIncomes] = useQuery(api.additionalIncomeList);
  const formatMessage = useFormatMessage();
  pipe(
    getAdditionalIncomes,
    remoteData.fold(
      constVoid,
      () => props.onError,
      response => props.onFinish(response.additionalIncomeList.length > 0)
    )
  );

  return (
    <Loader
      ariaLabelMessage={formatMessage(
        "generic.loading.alt" as RuntimeLocaleKey
      )}
    />
  );
}
